import React from 'react';
import SubjectPage from '../../Subjects/SubjectPage';

function TopperNote() {

    const pageTitleText = "JEE Topper Note ";

  return (
    <>
    
      <SubjectPage 
        name={pageTitleText} 
        link="toppernote" 
      />

    </>
  );
}

export default TopperNote;